import React, { useEffect } from 'react';
import { Spin, message } from 'antd';
// import { navigate } from '@reach/router';
import { useAuth } from '~context/authContext';

const SessionTimeout = ({ navigate }) => {
  const { isAuthenticated, logout } = useAuth();

  useEffect(() => {
    if (!!isAuthenticated) message.warn('Your session has timed out, please login to continue...');
  }, [isAuthenticated]);

  setTimeout(() => {
    logout();
    navigate('/');
  }, 2000);

  return <Spin tip="Returning to login..." spinning />;
};

export default SessionTimeout;
